import React from 'react'
import Link from 'next/link'

export default function FooterSmall(props) {
	return (
		<>
			<footer className='pb-6'>
				<div className='w-10/12 mx-auto px-4'>
					<hr className='mb-6 border-b-1 border-slate-600' />
					<div className='flex flex-wrap items-center md:justify-between justify-center'>
						<div className='w-full md:w-4/12 px-4'>
							<div className='text-sm text-slate-500 font-semibold py-1 text-center md:text-left'>
								Copyright © {new Date().getFullYear()} Xisaabiye by{' '}
								<a
									href='https://teckave.com'
									className='text-slate-500 hover:text-slate-800'
								>
									Teckave
								</a>
							</div>
						</div>
						<div className='w-full md:w-8/12 px-4'>
							<ul className='flex flex-wrap list-none md:justify-end  justify-center'>
								<li>
									<Link legacyBehavior href='/about' passHref>
										<a className='text-slate-600 hover:text-slate-800 text-sm font-semibold block py-1 px-3'>
											About
										</a>
									</Link>
								</li>
								<li>
									<Link legacyBehavior href='/contact' passHref>
										<a className='text-slate-600 hover:text-slate-800 text-sm font-semibold block py-1 px-3'>
											Contact
										</a>
									</Link>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</footer>
		</>
	)
}
